import React from 'react'
import "./certificateinoptician.css";
import { Carousel } from 'react-bootstrap';


import CCourseimg1 from '../../assets/Pathway.jpg';
import CCourseimg2 from '../../assets/courseheaderimg1.png';
import CCourseimg3 from '../../assets/courseheaderimg2.png';
import CCourseimg4 from '../../assets/courseheaderimg3.png';

function DiplomaInOptometry() {
  return (
    <div className='diploma-in-optometry'>


      <div className="banner-diploma">
        {/* Auto Sliding Banner */}
        <Carousel className="mb-5">
          <Carousel.Item>
            <img
              className="d-block w-100 "
              src={CCourseimg1}
              alt="First slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={CCourseimg2}
              alt="Second slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={CCourseimg3}
              alt="Third slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={CCourseimg4}
              alt="Forth slide"
            />
          </Carousel.Item>
        </Carousel>
      </div>

    <div className="diploma-optometry-container">
      <h1 className="diploma-title">DIPLOMA IN OPTOMETRY</h1> 

      <section className="section">
        <h2>Eligibility</h2>
        <p>Passed G.C.E. A/L with three (03) passes in Physical Science or Biological Science stream</p>
        <p>Or</p>
        <p>The candidate should have to have competence in Certificate In Ophthalmic Assistant</p>
      </section>

      <section className="section">
        <h2>Duration</h2>
        <p>02 years</p>
      </section>


      <section className="section">
        <h2>Course Fee</h2>
        <p>Admission Fee: 150,000 LKR</p>
        <p>Per Module: 45,000 LKR</p>
        <p>Scholarship Programme Available | Terms and Conditions Applied</p>
      </section>

      <section className="section">
        <h2>Scope</h2>
        <p>
          Investigation, examination, measurement, and evaluation of the eye and adnexa, and associated systemic factors,
          to detect, diagnose, and manage disease.
        </p>
      </section>

      <section className="section">
        <h2>Course Structure</h2>

        {/* First Year */}
        <h3><strong>First Year</strong></h3>
        <h4><strong>First Semester</strong></h4>
        <table className="course-table">
          <thead>
            <tr>
              <th>Module Code</th>
              <th>Module</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td>English</td>
            </tr>
            <tr>
              <td></td>
              <td>Information Technology</td>
            </tr>
            <tr>
              <td>DIP101</td>
              <td>General Anatomy & Physiology</td>
            </tr>
            <tr>
              <td>DIP102</td>
              <td>General & Ocular Microbiology</td>
            </tr>
            <tr>
              <td>DIP103</td>
              <td>Biochemistry</td>
            </tr>
            <tr>
              <td>DIP104</td>
              <td>Optics-Geometrical & Physical </td>
            </tr>
            <tr>
              <td>DIP105</td>
              <td>Ocular Anatomy & Physiology</td>
            </tr>
            <tr>
              <td>DIP106</td>
              <td>Pharmacology</td>
            </tr>
          </tbody>
        </table>
     

        <h4><strong>Second Semester</strong></h4>
        <table className="course-table">
          <thead>
            <tr>
              <th>Module Code</th>
              <th>Module</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>DIP201</td>
              <td>Ocular Pathology I</td>
            </tr>
            <tr>
              <td>DIP202</td>
              <td>Clinical Procedure I</td>
            </tr>
            <tr>
              <td>DIP203</td>
              <td>Visual Optics</td>
            </tr>
            <tr>
              <td>DIP204</td>
              <td>Dispensing Optics</td>
            </tr>
            <tr>
              <td>DIP205</td>
              <td>Physiology Of Vision</td>
            </tr>
            <tr>
              <td>DIP206</td>
              <td>General Medicine</td>
            </tr>
          </tbody>
        </table>
      

        {/* Second Year */}
        <h3><strong>Second Year</strong></h3>
        <h4><strong>Third Semester</strong></h4>
        <table className="course-table">
          <thead>
            <tr>
              <th>Module Code</th>
              <th>Module</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>DIP301</td>
              <td>Clinical Procedure II</td>
            </tr>
            <tr>
              <td>DIP302</td>
              <td>Ocular Pathology II</td>
            </tr>
            <tr>
              <td>DIP303</td>
              <td>Binocular Vision</td>
            </tr>
            <tr>
              <td>DIP304</td>
              <td>Contact Lens</td>
            </tr>
            <tr>
              <td>DIP305</td>
              <td>Geriatric & Pediatric Optometry</td>
            </tr>
            <tr>
              <td>DIP306</td>
              <td>Low Vision</td>
            </tr>
          </tbody>
        </table>

        <h4><strong>Fourth Semester</strong></h4>
        <table className="course-table">
          <thead>
            <tr>
              <th>Module Code</th>
              <th>Module</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>DIP401</td>
              <td>Public Health & Community Optometry</td>
            </tr>
            <tr>
              <td>DIP402</td>
              <td>Occupational Optometry</td>
            </tr>
            <tr>
              <td>DIP403</td>
              <td>Practice management</td>
            </tr>
            <tr>
              <td>DIP404</td>
              <td>Research Methodology & Professional Ethics</td>
            </tr>
            <tr>
              <td></td>
              <td>Project Work</td>
            </tr>
            <tr>
              <td></td>
              <td>Clinical Internship (OJT)</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="evaluation-section">
        <h2>Evaluation Pattern</h2>
        <ul>
          <li>Projects</li>
          <li>Assignments</li>
          <li>Continuous Assessment</li>
          <li>Presentation</li>
          <li>Final Exam (Theory & Practical)</li>
        </ul>
      </section>
    </div>


    <div className="how-to-apply-container">
      <h2 className="section-title">How to Apply</h2>
      <div className="steps-container">
        <div className="step">
          <div className="circle orange">
          <span>&#x270F;</span>
          </div>
          <h3 className="step-title">REGISTRATION</h3>
          <p>
            <a
              href="/registration-course"
              style={{ textDecoration: 'none' }}
            >
              To Register
            </a>
          </p>
        </div>
        {/* <div className="step">
            <div className="circle green">
              <span>&#128441;</span>
            </div>
             <h3 className="step-title">Guidelines</h3>
            <a href="/Guidelines.pdf" download className="download-button" style={{ textDecoration: 'none' }}>
              Download Guidelines
            </a>
            <div className="download-pdf"></div> 

        </div> */}
      </div>
      <div className="contact-us">
        <a href="/contactus" className="contact-button text-decoration-none">
          Contact Us <span>&#x2192;</span>
        </a>
      </div>
    </div>


    </div>
  )
}

export default DiplomaInOptometry